import { useNavigate } from 'react-router-dom';
// import useAuth from './UseAuth';
import { useEffect } from 'react';
import { isValidToken } from '../jwt/Jwt';


const AuthGuard = ({ children }) => { 
  const isAuthenticated = window.localStorage.getItem('auth');
  const accessToken = window.localStorage.getItem('accessToken');
  const navigate = useNavigate();

  useEffect(() => {  
    if (!accessToken && !isValidToken(accessToken) &&  !isAuthenticated) { 
      navigate('/auth/login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return children;
};

export default AuthGuard;
